import { useState } from "react";
import { currencyFormat } from "../../../services/helper";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
import { getFormObj, server_domain } from "../../../services/constants";
import { setError } from "../../../redux/appsettingSlice";
import { post } from "../../../services/axios";
import { Spinner } from "react-bootstrap";

const iframeStyles = {
  base: {
    color: "#fff",
    fontSize: "16px",
    iconColor: "#fff",
    "::placeholder": {
      color: "#a1a1a1",
    },
    ":-webkit-autofill": {
      color: "#fff",
    },
  },
  invalid: {
    iconColor: "#dc3545",
    color: "#dc3545",
  },
  complete: {
    iconColor: "#fff",
  },
};
const cardElementOpts = {
  iconStyle: "solid",
  style: iframeStyles,
  hidePostalCode: true,
};

const ExtendCheckoutForm = ({
  amount,
  clientSecret,
  onSuccessfulCheckout,
  id,
  reload,
}) => {
  const [isProcessing, setProcessingTo] = useState(false);
  const [checkoutError, setCheckoutError] = useState();
  const [card, setCard] = useState("");

  const stripe = useStripe();
  const elements = useElements();

  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const user_id = user?.user_id;

  const callCapturePayment = async (stripe_ref) => {
    let formData = getFormObj();
    formData.append("api_method", "redeem_voucher");
    formData.append("stripe_token", stripe_ref);
    formData.append("voucher_id", id);
    formData.append("redeem", "extend");
    formData.append("stripe_amount", amount?.amount);
    formData.append("months", amount?.duration);

    try {
      const response = await post(server_domain, formData);
      if (response.data.success === 1 && !response.data.error) {
        onSuccessfulCheckout(response.data.message);
        reload(id);
        setProcessingTo(false);
      } else if (response.data.error) {
        dispatch(
          setError({
            isShow: true,
            alert_title: response.data.alert_title,
            alert_text: response.data.alert_text,
            alert_action_button_title: response.data.alert_action_button_title,
            alert_action_url: response.data.alert_action_url,
            message: response.data.message,
          })
        );
        setProcessingTo(false);
      }
    } catch (err) {
      setError({
        isShow: true,
        alert_title: "Error",
        alert_text: "",
        alert_action_button_title: "",
        alert_action_url: "",
        message: err.toString(),
      });
      setProcessingTo(false);
    }
  };

  const doPayment = async (e) => {
    setProcessingTo(true);
    e.preventDefault();
    const cardElement = elements.getElement("card");
    const billingDetails = {
      name: card,
    };
    const paymentMethodReq = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: billingDetails,
    });

    if (paymentMethodReq.error) {
      setCheckoutError(paymentMethodReq.error.message);
      setProcessingTo(false);
      return;
    }

    const response = await stripe.confirmCardPayment(clientSecret, {
      payment_method: paymentMethodReq.paymentMethod.id,
    });
    if (
      response.paymentIntent &&
      response.paymentIntent.status === "succeeded"
    ) {
      const stripeRef = response.paymentIntent.id;
      callCapturePayment(stripeRef);
    } else {
      if (response.error) {
        setCheckoutError(response.error.message);
        setProcessingTo(false);
        return;
      }
      setCheckoutError("Failed to make the payment");
      setProcessingTo(false);
      return;
    }
  };

  // useEffect(() => {
  //   return () => {
  //     onSuccessfulCheckout("");
  //   };
  // }, []);

  return (
    <form className="d-flex flex-column gap-3" onSubmit={doPayment}>
      <div>
        <label htmlFor="cc-number" style={{ paddingBottom: 5 }}>
          Card Info
        </label>
        <CardElement
          options={cardElementOpts}
          onChange={(e) => setCard(e.target.value)}
          className="form-control"
        />
      </div>
      {checkoutError && <div className="text-danger">{checkoutError}</div>}

      <div className="payment-total">
        <div className="amount d-flex justify-content-end">
          Total to Pay: {currencyFormat(amount?.amount)}
        </div>

        <div className="text-center">
          <button
            style={{ cursor: "pointer" }}
            className="btn btn-lg btn-block cont-shop"
            type="submit"
            disabled={isProcessing || !stripe || !clientSecret}
          >
            {isProcessing ? "Processing..." : "Make Payment"}
            {isProcessing && <Spinner animation="border" size="sm ms-2" />}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ExtendCheckoutForm;
